import { render, staticRenderFns } from "./index.vue?vue&type=template&id=03025f2e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03025f2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03025f2e')) {
      api.createRecord('03025f2e', component.options)
    } else {
      api.reload('03025f2e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=03025f2e&scoped=true&", function () {
      api.rerender('03025f2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormItem/TSelect/index.vue"
export default component.exports